module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked-purple.61c46346.svg";